// Module
var code = " <sites-list> </sites-list> ";
// Exports
var _module_exports = code;;
var path = '/App/Components/SitesList/SitesList.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;